import { showError, validateForm } from 'application/utils/form-validation'

export function initGameFeedbackForm() {
  const form = document.querySelector<HTMLFormElement>(
    '[data-game-feedback-form]'
  )
  if (!form) return

  form.addEventListener('submit', (event) => {
    const absent = form.querySelector<HTMLInputElement>(
      'input[name="order[is_visited_client]"][value="-1"]'
    )?.checked
    if (absent) return

    let valid = validateForm(form)

    const content = form.querySelector<HTMLTextAreaElement>(
      'textarea[name="review[content]"]'
    )
    const markField = form.querySelector<HTMLElement>(
      '[data-field-name="review[mark]"]'
    )
    if (
      content &&
      markField &&
      content.value.trim() !== '' &&
      !markField.querySelector('input:checked')
    ) {
      showError(markField, 'Поставьте оценку — без неё отзыв не опубликуется')
      valid = false
    }

    if (valid) return

    event.preventDefault()
    form
      .querySelector<HTMLElement>('[data-error]:not(:empty)')
      ?.closest<HTMLElement>('[data-field]')
      ?.scrollIntoView({ block: 'center', behavior: 'smooth' })
  })
}
